module.exports = __webpack_public_path__ + "img/yonarezi.594c7c8a.png";